import RecipeInstructions from './recipe_instructions'

export default RecipeInstructions
